import { useGoodsCodes } from '@/shared/hooks/goodsCodes'
import { GenericCombobox } from '@/common'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export function CnCodeSelector({
  label,
  cnCode,
  filteredCnCodes,
  onCnCodeUpdate,
  aggregatedGoodsCategories,
  disabled,
  required = false
}: {
  label?: string
  cnCode: string
  filteredCnCodes?: string[]
  onCnCodeUpdate: (value: string) => void
  aggregatedGoodsCategories?: string[]
  disabled?: boolean
  required?: boolean
}) {
  const { t } = useTranslation()
  const { data: goodsCodes, refetch } = useGoodsCodes({
    aggregatedGoodsCategories
  })

  const cnCodeFormatted =
    goodsCodes?.map(goodsCode => ({
      label: `${goodsCode.goodsCode} - ${t(`goods:${goodsCode.goodsCode}`)}`,
      value: goodsCode.goodsCode
    })) || []

  const filteredCnCodeOptions = filteredCnCodes
    ? cnCodeFormatted.filter(code => filteredCnCodes?.includes(code.value))
    : cnCodeFormatted

  const selectedCnCode = filteredCnCodeOptions?.find(code => code.value === cnCode) || null

  const onChange = (cnCode: { label: string; value: string } | null) => {
    if (cnCode) {
      onCnCodeUpdate(cnCode.value)
    }
  }

  useEffect(() => {
    refetch()
  }, [])

  return (
    <GenericCombobox
      label={label}
      value={selectedCnCode}
      items={filteredCnCodeOptions}
      onChange={onChange}
      disabled={disabled}
      required={required}
    />
  )
}
